import React from 'react';
import { Form, Input } from 'antd';

const TripTime = () => {
    return (
        <Form.Item label="Czas spływu" name="tripTimeMinutes">
            <Input addonAfter="minut" />
        </Form.Item>
    );
};

export default TripTime;
